import {
  formatCurrency,
  formatStatusName,
  getStatusColor,
  getRankingColor,
  calculatePercentage,
  hexToRgba,
} from "@/utils/dashboardUtils";

export default {
  computed: {
    formattedLoadsByAccount() {
      const loadsByAccountData = this.data?.loadsByAccount?.data || [];
      return loadsByAccountData.map((account, index) => ({
        name: account.name,
        value: account.value,
        color: getRankingColor(index),
      }));
    },

    revenueLegendItems() {
      if (!this.data?.revenuePerMonth || !this.data.revenuePerMonth.series) {
        return [];
      }
      return this.data.revenuePerMonth.series.slice(0, 6).map((series, index) => ({
        name: series.name,
        shortName: series.name
          ? series.name
            .split(" ")
            .map((wordChar) => wordChar.charAt(0))
            .join("")
          : "",
        color: getRankingColor(index),
      }));
    },

    formattedTopAccountsLoads() {
      const topAccountsLoads = this.data?.topAccountsByLoads || [];
      return topAccountsLoads.map((account, index) => ({
        name: account.name,
        value: account.value,
        color: getRankingColor(index),
      }));
    },

    formattedTopAccountsRevenue() {
      const topAccountsRevenue = this.data?.topAccountsByRevenue || [];
      return topAccountsRevenue.map((account, index) => ({
        name: account.name,
        value: account.value,
        color: getRankingColor(index),
        displayValue: formatCurrency(account.value),
      }));
    },

    processedStatusData() {
      const statusData = [
        {
          status: 'quoted',
          title: 'Quoted',
          total: this.data?.loadsQuoted?.total || 0,
          accounts: this.data?.loadsQuoted?.accounts || []
        },
        {
          status: 'assigned',
          title: 'Assigned',
          total: this.data?.loadsAssigned?.total || 0,
          accounts: this.data?.loadsAssigned?.accounts || []
        },
        {
          status: 'in_transit',
          title: 'In Transit',
          total: this.data?.loadsInTransit?.total || 0,
          accounts: this.data?.loadsInTransit?.accounts || []
        },
        {
          status: 'delivered',
          title: 'Delivered',
          total: this.data?.loadsDelivered?.total || 0,
          accounts: this.data?.loadsDelivered?.accounts || []
        }
      ];

      return statusData.map((statusItem) => {
        const filteredAccounts = statusItem.accounts
          .filter((account) => account.value > 0)
          .sort((accountA, accountB) => accountB.value - accountA.value)
          .slice(0, 3); // Take only top 3
        const maxValue = Math.max(...filteredAccounts.map((account) => account.value), 1);

        return {
          ...statusItem,
          color: getStatusColor(statusItem.status),
          accounts: filteredAccounts.map((account) => ({
            ...account,
            percentage: calculatePercentage(account.value, maxValue),
          })),
        };
      });
    },
  },

  methods: {
    formatCurrency,
    formatStatusName,
    hexToRgba,
  },
};
